import Reveal from '@/components/Reveal';
import { homeMock } from '@/mocks/home';

export default function Pricing() {
  return (
    <section id="pricing" className="w-full bg-mahjong-bg py-32 md:py-44">
      <div className="px-6 md:px-10 lg:px-16">
        {/* Header */}
        <Reveal className="mb-16 md:mb-24 md:ml-auto md:w-1/2" variant="slide-left">
          <p className="mb-3 font-sans text-sm tracking-wider text-mahjong-warm">
            {homeMock.pricing.subtitle}
          </p>
          <h2 className="whitespace-pre-line font-serif text-2xl font-bold leading-relaxed text-mahjong-dark md:text-4xl lg:text-5xl">
            {homeMock.pricing.title}
          </h2>
        </Reveal>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-10">
          {homeMock.pricing.courses.map((course, index) => (
            <Reveal
              key={course.name}
              delay={index * 100}
              className={index % 2 === 1 ? 'md:mt-16' : ''}
            >
            <div
              className={`${course.bgColor} overflow-hidden rounded-2xl transition-all duration-300 hover:-translate-y-2 hover:rotate-[0.5deg] hover:shadow-xl`}
            >
              {/* Image Area */}
              <div className="relative h-[260px] md:h-[320px]">
                <img
                  src={course.image}
                  alt={course.name}
                  className="h-full w-full object-cover object-top"
                />
              </div>

              {/* Info Area */}
              <div className="p-5 md:p-7">
                <h3 className="mb-1 font-serif text-lg font-bold text-mahjong-dark md:text-2xl">
                  {course.name}
                </h3>
                <p className="mb-4 font-sans text-xs text-mahjong-warm">
                  {course.description}
                </p>
                <div className="mb-5 flex items-baseline gap-1">
                  <span className="font-serif text-4xl font-bold text-mahjong-dark">
                    {course.price}
                  </span>
                  <span className="font-sans text-sm text-mahjong-warm">
                    {course.unit}
                  </span>
                </div>
                <ul className="space-y-2">
                  {course.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2 font-sans text-sm text-mahjong-dark/80">
                      <i className="ri-check-line text-mahjong-primary" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}